import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Tabs,
  Tab,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// ✅ Set API Base URL dynamically
const API_BASE_URL = window.__ENV__?.API_URL || "https://m2oi2mvv2e.execute-api.ap-south-1.amazonaws.com/Prod/api";

export default function AuthPage() {
  const [tab, setTab] = useState(0);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    name: "",
    phone: "",
    role: "employee",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(""); // Reset errors

    try {
      if (tab === 0) {
        // ✅ Login Request
        const response = await axios.post(
          `${API_BASE_URL}/login`,
          {
            email: formData.email,
            password: formData.password,
          },
          {
            withCredentials: true, // 👈 Required for cross-origin requests with credentials
          }
        );

        if (response.status === 200 && response.data.userId) {
          // ✅ Store user info in localStorage
          localStorage.setItem("userId", response.data.userId);
          localStorage.setItem("role", response.data.role);

          alert("Login Successful");

          // Redirect based on role
          navigate(response.data.role === "admin" ? "/admin" : "/timesheet");
        } else {
          setErrorMessage("Invalid email or password");
        }
      } else {
        // ✅ Signup Request
        await axios.post(`${API_BASE_URL}/signup`, formData, {
          withCredentials: true,
        });

        alert("Sign Up Successful! Please login.");
        setTab(0); // Switch to Login tab
      }
    } catch (error) {
      console.error("Auth Error:", error);
      setErrorMessage(
        error.response?.data?.message ||
          "An error occurred. Please try again."
      );
    }
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ padding: 3, mt: 5, textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          Evolve X Employee Portal
        </Typography>

        <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} centered>
          <Tab label="Login" />
          <Tab label="Sign Up" />
        </Tabs>

        {tab === 0 ? (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              margin="normal"
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required
              margin="normal"
            />
            {errorMessage && (
              <Typography color="error" sx={{ mt: 1 }}>
                {errorMessage}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
            >
              Login
            </Button>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Full Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              margin="normal"
            />
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
              margin="normal"
            />
            <TextField
              fullWidth
              label="Phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
              required
              margin="normal"
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required
              margin="normal"
            />
            <TextField
              select
              fullWidth
              label="Role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              margin="normal"
            >
              <MenuItem value="employee">Employee</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </TextField>
            {errorMessage && (
              <Typography color="error" sx={{ mt: 1 }}>
                {errorMessage}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
            >
              Sign Up
            </Button>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
